<div class="edit-fasting-container">
  <div class="edit-fasting-top-holder">
    <div class="edit-fasting-top" (swipedown)="swipe($event.type)">
      <div class="edit-fasting-top-indicator"></div>
    </div>
    <div class="edit-fasting-title">شروع {{ data.title }}</div>
    <div class="edit-fasting-submit" (click)="submit()">ثبت</div>
    <div class="edit-fasting-cancel" (click)="cancel()">انصراف</div>
  </div>
  <div class="edit-fasting-holder">
    <div class="edit-fasting-minutes" id="fastingMinutes">
      <div
        *ngFor="let minute of minutes; let i = index"
        class="edit-fasting-minute"
      >
        <div *ngIf="minute < 10">۰{{ minute }}</div>
        <div *ngIf="minute >= 10">
          {{ minute }}
        </div>
      </div>
    </div>
    <div
      class="edit-fasting-minutes-gesture"
      (swipeup)="swipeMinutes($event.type, $event)"
      (swipedown)="swipeMinutes($event.type, $event)"
    ></div>
    <div class="edit-fasting-dot">:</div>
    <div class="edit-fasting-hours" id="fastingHours">
      <div *ngFor="let hour of hours; let i = index" class="edit-fasting-hour">
        <div *ngIf="hour < 10">۰{{ hour }}</div>
        <div *ngIf="hour >= 10">
          {{ hour }}
        </div>
      </div>
    </div>
    <div
      class="edit-fasting-hours-gesture"
      (swipeup)="swipeHours($event.type, $event)"
      (swipedown)="swipeHours($event.type, $event)"
    ></div>
    <div class="edit-fasting-days" id="fastingDays">
      <div *ngFor="let day of days; let i = index" class="edit-fasting-day">
        {{ day }}
      </div>
    </div>
    <div
      class="edit-fasting-days-gesture"
      (swipeup)="swipeDays($event.type)"
      (swipedown)="swipeDays($event.type)"
    ></div>
    <div class="edit-fasting-line-top">
      <div class="edit-fasting-white-top"></div>
      <div class="edit-fasting-gradient-top"></div>
    </div>
    <div class="edit-fasting-line-bot">
      <div class="edit-fasting-gradient-bot"></div>
      <div class="edit-fasting-white-bot"></div>
    </div>
  </div>
  <div *ngIf="showLoading" class="spinner-holder">
    <mat-spinner *ngIf="showLoading" class="spinner"></mat-spinner>
  </div>
</div>
